import angular from 'angular';
import './packagesServices';

/**
 * @ngdoc overview
 * @name superuserModule.packagesControllers
 * @description
 * # superuserModule.packagesControllers
 * Module for managing the controllers of: client packages.
 *
 * Package is a set of read/write permissions to the modules. It's used for allowing/blocking client access to certain modules.
 */
const packagesControllers = angular.module('superuserModule.packagesControllers', ['superuserModule.packagesServices']);

/**
 * @ngdoc controller
 * @name superuserModule.packagesControllers.controller:PackagesListController
 * @description
 * Controller for the list of packages
 */
packagesControllers.controller('PackagesListController', ['$scope', 'NgTableParams', 'Package', 'AppsoupAPI', function ($scope, NgTableParams, Package, AppsoupAPI) {
    'use strict';

    $scope.search = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Package.getList(params && params._params ? params._params : {})
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.searchPackages = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
}]);

/**
 * @ngdoc controller
 * @name superuserModule.packagesControllers.controller:PackagePageController
 * @description
 * Controller for the specific package creation or edit.
 */
packagesControllers.controller('PackagePageController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', 'growl', 'Package', 'SystemModules', function ($scope, $rootScope, $state, $stateParams, $translate, growl, Package, SystemModules) {
    'use strict';

    const packageId = $stateParams.packageId;

    const goToPackageList = function () {
        $state.go('appsoup.admin.packages');
    };

    $scope.module = {};

    if (angular.isDefinedNotEmpty(packageId)) {
        $scope.editMode = true;

        $rootScope.doingResolve = true;
        Package.get(packageId)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    const clientPackage = data.package;
                    $scope.package = {id: clientPackage.id, name: clientPackage.name};
                    $scope.module = SystemModules.getReadWriteModules(clientPackage);
                } else if (angular.isDefined(data.error)) {
                    growl.error('MODULES.PACKAGES.' + data.error);
                    if (data.error === 'ERROR.NO_RESOURCE') {
                        goToPackageList();
                    }
                }
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    } else {
        $scope.module = SystemModules.getReadWriteModules({});
    }

    $scope.savePackage = function () {
        $scope.$broadcast('show-errors-check-validity');

        if (angular.isDefined($scope.module) && SystemModules.countPermissions($scope.module) > 0 && $scope.packageForm.$valid) {

            $scope.isLoading = true;
            $scope.package = angular.extend($scope.package, SystemModules.getPermissions($scope.module));

            Package.save($scope.package, $scope.editMode)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        goToPackageList();
                        growl.success('MODULES.PACKAGES.SUCCESS.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                    } else {
                        $scope.formErrors = data.error;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        } else {
            growl.error($translate.instant('MODULES.PACKAGES.ERROR.NOT_CHOSEN'), {referenceId: 1});
        }
    };

    $scope.deletePackage = function () {
        $scope.isDeleting = true;
        Package.remove($scope.package.id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    goToPackageList();
                    growl.success('MODULES.PACKAGES.SUCCESS.DELETE');
                }
            })
            .finally(function () {
                $scope.isDeleting = false;
            });
    };

    $scope.cancel = function () {
        goToPackageList();
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}]
    };
}]);

export default packagesControllers;
